<template>
  <Dropdown :transfer="true" trigger="click" @on-click="actionTrigger">
    <VolumeExtend ref="VolumeExtend" v-on:callback="$emit('callback')"></VolumeExtend>
    <VolumeUpdateStatus ref="VolumeUpdateStatus" v-on:callback="$emit('callback')"></VolumeUpdateStatus>
    <VolumeBootable ref="VolumeBootable" v-on:callback="$emit('callback')"></VolumeBootable>
    <VolumeUploadImage ref="VolumeUploadImage" v-on:callback="$router.push({ name: 'image' })"></VolumeUploadImage>
    <VolumeSetUnManage ref="VolumeSetUnManage" v-on:callback="$emit('callback')"></VolumeSetUnManage>
    <VolumeDelete ref="VolumeDelete" v-on:callback="$emit('callback')"></VolumeDelete>
    <VolumeRevertSnapshot ref="VolumeRevertSnapshot" v-on:callback="$emit('callback')"></VolumeRevertSnapshot>
    <VolumeLink ref="VolumeLink" v-on:callback="$emit('callback')"></VolumeLink>
    <SnapshotEdit ref="SnapshotEdit" v-on:editComplete="$router.push({ name: 'snapshots' })"></SnapshotEdit>
    <BackupEdit ref="BackupEdit" v-on:editComplete="$router.push({ name: 'backups' })"></BackupEdit>
    <Button type="dashed" size="small">
      更多操作
      <Icon type="ios-arrow-down"></Icon>
    </Button>
    <DropdownMenu slot="list">
      <DropdownItem name="os-extend" v-if="status === 'available'">扩展</DropdownItem>
      <DropdownItem name="os-reset_status">重设云硬盘状态</DropdownItem>
      <DropdownItem name="os-set_bootable">设置是否可启动</DropdownItem>
      <DropdownItem name="os-volume_upload_image" v-if="status !== 'uploading'">上传镜像</DropdownItem>
      <DropdownItem name="create_snapshot" v-if="status === 'available'">创建快照</DropdownItem>
      <!--<DropdownItem name="revert" v-if="status === 'available'">还原快照</DropdownItem>-->
      <DropdownItem name="create_backup" v-if="status === 'available'">备份</DropdownItem>
      <!--<DropdownItem name="os-set_image_metadata">查看镜像元数据</DropdownItem>-->
      <!--<DropdownItem name="os-set_image_metadata">配置镜像元数据</DropdownItem>-->
      <!--<DropdownItem name="os-unset_image_metadata">删除镜像元数据</DropdownItem>-->
      <DropdownItem name="os-attach">管理连接</DropdownItem>
      <!--<DropdownItem name="os-detach" v-if="status === 'in-use'">从实例分离</DropdownItem>-->
      <!--<DropdownItem name="os-retype" v-if="status === 'available'">修改卷类型</DropdownItem>-->
      <!--<DropdownItem name="os-migrate_volume"-->
                    <!--v-if="(status === 'available' || status === 'in-use') &&-->
                  <!--(migration_status === null || migration_status === 'deleting' || migration_status === 'error' || migration_status === 'success') &&-->
                  <!--(replication_status === null || replication_status === 'disabled' || replication_status === 'not-capable')">迁移卷</DropdownItem>-->
      <!--<DropdownItem name="os-migrate_volume_completion" v-if="">完成迁移</DropdownItem>-->
      <DropdownItem name="os-unmanage" v-if="status === 'available'"><span :style="{color: 'red'}">设为非管理状态</span></DropdownItem>
      <!--<DropdownItem name="os-force_delete"><span :style="{color: 'red'}">强制删除卷</span></DropdownItem>-->
      <DropdownItem name="delete"
                    v-if="status === 'available' || status === 'error' || status === 'error_restoring' || status === 'error_extending' || status === 'error_managing'">
        <span :style="{color: 'red'}">删除云硬盘</span>
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import VolumeExtend from './action/volume-extend'
import VolumeUpdateStatus from './action/volume-update-status'
import VolumeBootable from './action/volume-bootable'
import VolumeUploadImage from './action/volume-upload-image'
import VolumeSetUnManage from './action/volume-set-unmanage'
import VolumeDelete from './action/volume-delete'
import VolumeRevertSnapshot from './action/volume-revert-snapshot'
import VolumeLink from './action/volume-link'
import SnapshotEdit from './snapshot-edit'
import BackupEdit from './backup-edit'

export default {
  name: 'volume-action-menu',
  components: {
    VolumeExtend,
    VolumeUpdateStatus,
    VolumeBootable,
    VolumeUploadImage,
    VolumeSetUnManage,
    VolumeDelete,
    VolumeRevertSnapshot,
    VolumeLink,
    SnapshotEdit,
    BackupEdit
  },
  props: {
    status: String,
    migration_status: String,
    replication_status: String,
    volume_id: String,
    volume_name: String
  },
  data () {
    return {

    }
  },
  methods: {
    actionTrigger (name) {
      switch (name) {
        case 'os-extend':
          this.$refs.VolumeExtend.openModal(this.volume_id)
          break
        case 'os-reset_status':
          this.$refs.VolumeUpdateStatus.openModal(this.volume_id, this.status)
          break
        case 'os-set_bootable':
          this.$refs.VolumeBootable.openModal(this.volume_id)
          break
        case 'os-volume_upload_image':
          this.$refs.VolumeUploadImage.openModal(this.volume_id, this.status)
          break
        case 'os-unmanage':
          this.$refs.VolumeSetUnManage.openConfirm(this.volume_id, this.status)
          break
        case 'delete':
          this.$refs.VolumeDelete.openConfirm(this.volume_id)
          break
        case 'create_snapshot':
          this.$refs.SnapshotEdit.openModal(this.volume_id)
          break
        case 'revert':
          this.$refs.VolumeRevertSnapshot.openModal(this.volume_id, this.status)
          break
        case 'create_backup':
          this.$refs.BackupEdit.openModal(this.volume_id)
          break
        case 'os-attach':
          this.$refs.VolumeLink.openModal(this.volume_id)
          break
      }
    }
  }
}
</script>

<style scoped>

</style>
